// ActionType for VatPeriodExport

//VAT Invoice List
export const VAT_INVOICE_LIST = "VAT_INVOICE_LIST";
export const VAT_INVOICE_LIST_SUCCESS = "VAT_INVOICE_LIST_SUCCESS";
export const VAT_INVOICE_LIST_FAIL = "VAT_INVOICE_LIST_FAIL";

// VAT invoice Item List
export const VAT_INVOICE_ITEM_LIST = "VAT_INVOICE_ITEM_LIST";
export const VAT_INVOICE_ITEM_LIST_SUCCESS = "VAT_INVOICE_ITEM_LIST_SUCCESS";
export const VAT_INVOICE_ITEM_LIST_FAIL = "VAT_INVOICE_ITEM_LIST_FAIL";

//Vat Purchase List
export const VAT_PURCHASE_LIST = "VAT_PURCHASE_LIST";
export const VAT_PURCHASE_LIST_SUCCESS = "VAT_PURCHASE_LIST_SUCCESS";
export const VAT_PURCHASE_LIST_FAIL = "VAT_PURCHASE_LIST_FAIL";

//Vat Purchase Item List
export const VAT_PURCHASE_ITEM_LIST = "VAT_PURCHASE_ITEM_LIST";
export const VAT_PURCHASE_ITEM_LIST_SUCCESS = "VAT_PURCHASE_ITEM_LIST_SUCCESS";
export const VAT_PURCHASE_ITEM_LIST_FAIL = "VAT_PURCHASE_ITEM_LIST_FAIL";
